import { cloneState, findPileWithCard, type GameState } from './game-state.js';
import type { SolitaireRules } from './rules.js';

export interface Move {
  readonly from: string;
  readonly to: string;
  readonly cardId: string;
}

export function applyMove(state: GameState, move: Move, rules: SolitaireRules): GameState | null {
  if (!rules.canMove(state, move)) return null;

  const next = cloneState(state);
  const fromPile = next.piles[move.from];
  const toPile = next.piles[move.to];
  if (!fromPile || !toPile) return null;

  const idx = fromPile.cards.findIndex((c) => c.id === move.cardId);
  if (idx === -1) return null;

  const moving = fromPile.cards.splice(idx);
  toPile.cards.push(...moving);
  next.movesCount++;

  rules.afterMove?.(next, move);
  return next;
}

export function locateCard(state: GameState, cardId: string) {
  const pile = findPileWithCard(state, cardId);
  if (!pile) return null;
  const index = pile.cards.findIndex((c) => c.id === cardId);
  return { pile, index };
}
